import * as Sentry from "@sentry/browser";

const urlSearchParams = new URLSearchParams(window.location.search);
let appendDebugInfo;

if (urlSearchParams.get('debug')) {
    // CSS for debug panel
    const debugPanelCSS = `
    #debugPanel {
      position: fixed;
      top: 0;
      right: 0;
      width: 250px;
      background-color: rgba(0, 0, 0, 0.8);
      color: #ddd;
      padding: 10px;
      font-size: 14px;
      z-index: 9999;
    }
    #debugPanel ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    #debugPanel li {
      margin-bottom: 5px;
    }
  `;

    // Create and append debug panel
    const debugPanel = document.createElement('div');
    debugPanel.id = 'debugPanel';
    debugPanel.innerHTML = '<ul></ul>';
    document.body.appendChild(debugPanel);

    // Add debug panel CSS to the head
    const debugPanelStyle = document.createElement('style');
    debugPanelStyle.textContent = debugPanelCSS;
    document.head.appendChild(debugPanelStyle);

    // Function to append debug information
    // Function to append debug information
    appendDebugInfo = message => {
        const listItem = document.createElement('li');
        listItem.textContent = message;
        debugPanel.querySelector('ul').appendChild(listItem);
    };


} else {
    // Stub function when "debug" query parameter is not present
    appendDebugInfo = () => {};
}

export function measureTime(fn) {
    return async function(...args) {
        const startTime = performance.now();
        const result = await fn(...args);
        const endTime = performance.now();
        const duration = (endTime - startTime).toFixed(2);

        appendDebugInfo(`${fn.name}: ${duration} ms`);

        return result;
    };
}

export { appendDebugInfo };

